import React from 'react';
import SaasHeroIntegrationRail from './SaasHeroIntegrationRail';
import SaasHeroRoiFloat from './SaasHeroRoiFloat';
import SaasRetentionFloat from './SaasRetentionFloat';
import SaasHeroPhone from './SaasHeroPhone';

const phoneWidth = 'w-[min(308px,calc(100vw-3.25rem))]';

export default function SaasHeroVisualMobile() {
  return (
    <div className="mx-auto w-full max-w-[100vw] py-4 flex justify-center px-2">
      <div className="w-full flex flex-col items-center">
        <div className="mb-2.5 flex w-full justify-center px-1 z-30 pointer-events-none">
          <div className={`${phoneWidth} max-w-full`}>
            <SaasHeroRoiFloat compact centered />
          </div>
        </div>

        <div className={`relative mx-auto shrink-0 select-none z-10 ${phoneWidth}`}>
          <SaasHeroPhone mobile className="h-[648px] max-h-[min(82vh,680px)] w-full" />
          <aside
            className="absolute top-[4.25rem] right-2.5 z-30 pointer-events-none"
            aria-hidden
          >
            <SaasRetentionFloat compact inset />
          </aside>
        </div>

        <div className="mt-5 flex w-full justify-center px-2 pointer-events-none z-20">
          <SaasHeroIntegrationRail centered />
        </div>
      </div>
    </div>
  );
}
